class Slice {

    constructor(sampler, sliceNumber) {
        this.sampler = sampler;
        this.sliceNumber = sliceNumber;
    }

    get start() {
        return this.sampler.getStartTime(this.sliceNumber);
    }

    get end() {
        return this.sampler.getEndTime(this.sliceNumber);
    }

    set start(newStart) {
        this.sampler.slice(this.sliceNumber, newStart, this.end);
    }

    set end(newEnd) {
        this.sampler.slice(this.sliceNumber, this.start, newEnd);
    }

}

export default Slice;
